import { useFormik } from "formik";

export function SchemaForm(
  submit,
  initialVal,
  cb,
  checkSchemaData
) {
  const validation = (values) => {
    let errors = {};
    let schemaError = false;
    // Structured data is optional, but a malformed blob is worse than none —
    // the storefront drops it straight into a ld+json script tag.
    if (values.schema && values.schema.trim() !== "") {
      try {
        JSON.parse(values.schema);
      } catch (e) {
        errors.schema = "Schema must be valid JSON";
        schemaError = true;
      }
    }
    checkSchemaData(schemaError);
    if (cb) {
      cb(values);
    }
    return errors;
  };

  const initialValues = {
    schema: "",
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialVal || initialValues,
    onSubmit: submit,
    validate: validation,
  });
  return { formik };
}
